export default "__VITE_ASSET__b580e8d7__"